import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { ViewCell } from "ng2-smart-table";

@Component({
  selector: "button-view",
  template: `
    <button
      nbButton
      shape="round"
      outline
      status="success"
      size="small"
      (click)="onClick()"
    >
      <nb-icon icon="checkmark-outline"></nb-icon>
    </button>
  `,
})
export class StbCustomRenderButtonComponent implements ViewCell, OnInit {
  renderValue: string;

  @Input() value: string | number;
  @Input() rowData: any;

  @Output() onSelected: EventEmitter<any> = new EventEmitter();

  ngOnInit() {
    this.renderValue = this.value.toString().toUpperCase();
  }

  onClick() {
    console.log("onClick:", this.rowData);
    this.onSelected.emit(this.rowData);
  }
}
